import React from 'react';

interface NavTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const NavTabs: React.FC<NavTabsProps> = ({ activeTab, onTabChange }) => {

  const tabs = [
    { id: 'live', label: 'Live', icon: '🔴' },
    { id: 'today', label: 'Heute', icon: '📅' },
    { id: 'football', label: 'Fußball', icon: '⚽' },
    { id: 'tipclub', label: 'TipClub', icon: '🎯' },
    { id: 'million', label: 'Million', icon: '💰' },
  ];

  return (
    <nav className="bg-tipico-red overflow-x-auto">
      <div className="flex gap-2 px-4 py-3">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center gap-1 px-4 py-2 rounded-lg whitespace-nowrap transition ${
              activeTab === tab.id && activeTab !== ''
                ? 'bg-tipico-red-dark text-white shadow-inner'
                : 'text-white hover:bg-tipico-red-dark/50'
            }`}
          >
            <span className="text-xl">{tab.icon}</span>
            <span className="text-xs font-semibold">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default NavTabs;
